export default "__VITE_ASSET__b1c5b0cd__"